export const BiodevMessages = {
  login: {
    submit: "Sign in",
  },
}
